import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiGift, FiArrowRight } = FiIcons;

const ExitIntentModal = ({ onClose }) => {
  return (
    <motion.div
      className="fixed inset-0 z-50 flex items-center justify-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} />
      <motion.div
        className="relative bg-white rounded-2xl p-8 max-w-md mx-4 text-center border border-blue-200 shadow-2xl"
        initial={{ scale: 0.8, y: 50 }}
        animate={{ scale: 1, y: 0 }}
        exit={{ scale: 0.8, y: 50 }}
        transition={{ type: "spring", damping: 25, stiffness: 300 }}
      >
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-900 transition-colors">
          <SafeIcon icon={FiX} className="text-xl" />
        </button>
        <div className="mb-6">
          <div className="w-16 h-16 bg-gold/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <SafeIcon icon={FiGift} className="text-gold text-2xl" />
          </div>
          <h3 className="font-serif text-2xl font-bold mb-4 text-gray-900">
            Wait! Don't Miss This{' '}
            <span className="text-primary-blue">FY End Deal</span>
          </h3>
          <p className="text-gray-700 mb-6">
            Before you go, get a FREE onboarding call (worth ₹5,000) when you purchase any Financial Year End plan today!
          </p>
        </div>
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6">
          <h4 className="font-bold text-primary-blue mb-2">🎁 EXCLUSIVE BONUS</h4>
          <p className="text-sm text-gray-700">
            Personal 1-on-1 onboarding call + Custom funnel setup + 30-day success roadmap (FREE with any purchase)
          </p>
        </div>
        <div className="space-y-3">
          <motion.button
            className="w-full bg-primary-blue hover:bg-dark-blue text-white px-6 py-4 rounded-xl font-bold transition-all hover-glow flex items-center justify-center space-x-2 border-2 border-gold"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => { document.getElementById('pricing').scrollIntoView({ behavior: 'smooth' }); onClose(); }}
          >
            <span>Claim My FY End Deal</span>
            <SafeIcon icon={FiArrowRight} />
          </motion.button>
          <button className="w-full text-gray-500 hover:text-gray-900 transition-colors text-sm" onClick={onClose}>
            No thanks, I'll pay full price later
          </button>
        </div>
        <p className="text-xs text-gray-500 mt-4">7-day money-back guarantee • Secure checkout</p>
      </motion.div>
    </motion.div>
  );
};

export default ExitIntentModal;